var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"17","viewBox":"0 0 22 17"}},_vm.$listeners),[_c('path',{attrs:{"fill-rule":"evenodd","d":"M18.425 0L8.454 9.899 3.575 5.056 0 8.607 8.451 17 22 3.549z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }